<script lang="ts">
  import { get } from 'svelte/store';
  import { stats } from '../lib/stores/stats';
  import { filters } from '../lib/stores/filters';
  import { loadFeed } from '../lib/stores/feed';
  import { toggleTheme } from '../lib/theme';
  import { relativeAge } from '../lib/format';
  import { api } from '../lib/api';
  import { session } from '../lib/stores/session';
  import { pushToast } from '../lib/stores/toasts';
  import HealthDot from './HealthDot.svelte';

  // Freshness hiển thị mốc mới nhất giữa 3 nguồn — health dot riêng mới cho biết
  // nguồn nào đang lỗi.
  function latestOf(a: string | null | undefined, b: string | null | undefined): string | null {
    if (!a) return b ?? null;
    if (!b) return a;
    return new Date(a).getTime() >= new Date(b).getTime() ? a : b;
  }
  const lastFetch = $derived(
    latestOf(
      latestOf($stats?.ebay_health.last_fetch_at, $stats?.poshmark_health.last_fetch_at),
      $stats?.mercari_health.last_fetch_at,
    ),
  );
  const freshness = $derived(
    lastFetch ? `cập nhật ${relativeAge(lastFetch)} trước` : 'chưa cập nhật',
  );
  const newCount = $derived($stats?.new_since_last_visit ?? 0);

  function reload(): void {
    void loadFeed(get(filters));
  }

  // Best-effort: clear the server-side cookie, but always end the client
  // session — an unreachable server is not a reason to keep the user stuck
  // looking logged in.
  async function doLogout(): Promise<void> {
    try {
      await api.logout();
    } catch (e) {
      pushToast(`Đăng xuất phía máy chủ thất bại: ${(e as Error).message}`, { ms: 4000 });
    }
    session.set('out');
  }
</script>

<header class="topbar">
  <span class="wordmark">Watch<b>feed</b></span>
  <span class="fetch">
    <HealthDot health={$stats?.ebay_health.fetch_health} label="eBay" />
    <HealthDot health={$stats?.poshmark_health.fetch_health} label="Poshmark" />
    <HealthDot health={$stats?.mercari_health.fetch_health} label="Mercari" />
    {freshness}
  </span>
  {#if newCount > 0}
    <button class="newcount" onclick={reload}>{newCount} mới</button>
  {/if}
  <span class="spacer"></span>
  <button
    class="tbtn"
    aria-label="Đổi giao diện sáng/tối"
    title="Đổi giao diện sáng/tối"
    onclick={() => toggleTheme()}
  >◐</button>
  <button
    class="tbtn"
    aria-label="Đăng xuất"
    title="Đăng xuất"
    onclick={() => void doLogout()}
  >⏻</button>
</header>
